import React, { useMemo } from 'react';
import { AlertClientBadge } from '../../styled';
import { useQueueContentChatContext } from 'hooks/useQueueContentChat';

const AlertCustomerTag = ({ chatId, situation, status }) => {
  const {
    chatsCustomerWithoutInteractionCritical,
    chatsCustomerWithoutInteractionWarning
  } = useQueueContentChatContext();

  const type = useMemo(() => {
    if (chatsCustomerWithoutInteractionCritical.has(chatId)) {
      return 'critical';
    }
    if (chatsCustomerWithoutInteractionWarning.has(chatId)) {
      return 'warning';
    }
    return 'default';
  }, [
    chatId,
    chatsCustomerWithoutInteractionCritical,
    chatsCustomerWithoutInteractionWarning
  ]);

  return (
    <h4 className="mt--2">
      <AlertClientBadge type={type} situation={situation}>
        {status}
      </AlertClientBadge>
    </h4>
  );
};
export default AlertCustomerTag;
